<div [ngClass]="styleClass">
  <i class="fas fa-eye-slash mr-1"></i>
  <span translate>{{ message }}</span>
</div>
